import React, { useEffect, useState } from "react";
import {
  f7,
  Page,
  Link,
  Navbar,
  NavTitle,
  NavRight,
  Button,
  Badge,
  Toolbar,
  Tabs,
  Tab,
  Block,
  BlockTitle,
  Popup,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  List,
  ListItem,
  ListItemCell,
  ListInput,
  Icon,
  Range,
  Row,
  Col,
  Input,
  AccordionItem,
  AccordionToggle,
  AccordionContent,
} from "framework7-react";

function DeliveryPriceCity({
  country,
  state,
  city,
  cityData,
  editDeliveryPrice,
  deleteDeliveryPrice,
}) {
  const [deliveryCharge, setDeliveryCharge] = useState("");
  const [kmPerDeliveryCharge, setKmPerDeliveryCharge] = useState("");
  const [buttonSave, setButtonSave] = useState(false);

  const edit = () => {
    let data = {};
    if (deliveryCharge) {
      data.deliveryCharge = Number(deliveryCharge);
    }

    if (kmPerDeliveryCharge) {
      data.kmPerDeliveryCharge = Number(kmPerDeliveryCharge);
    }
    editDeliveryPrice(country, state, city, data).then(() => {
      setDeliveryCharge("");
      setKmPerDeliveryCharge("");
    });
  };

  return (
    <Card
      className="border-radius-0 elevation-0"
      style={{ margin: "auto" }}
    >
      <CardHeader className="border-radius-0 bg-color-gray-50">
      {`${city} Delivery Price`}
      </CardHeader>
      <CardContent className="">
        <List simpleList>
          <ListItem>
            <ListItemCell className="width-auto flex-shrink-0">
              <Icon f7="creditcard"></Icon>
            </ListItemCell>
            <ListItemCell className="flex-shrink-3">
              <p>Below 2km</p>
            </ListItemCell>
            <ListItemCell className="width-auto flex-shrink-4">
              <input
                type="number"
                style={{
                  textAlign: "center",
                }}
                placeholder={cityData.deliveryCharge}
                value={deliveryCharge}
                onChange={(e) => setDeliveryCharge(e.target.value)}
                onFocus={_ => setButtonSave(true)}
                onBlur={_ => setButtonSave(false)}
              />
            </ListItemCell>
            <ListItemCell className="width-auto flex-shrink-0">
              <h6>
                [<span>NGN {deliveryCharge || cityData.deliveryCharge}</span>
                {"<= 2km"}]
              </h6>
            </ListItemCell>
          </ListItem>

          <ListItem>
            <ListItemCell className="width-auto flex-shrink-0">
              <Icon f7="creditcard"></Icon>
            </ListItemCell>
            <ListItemCell className="flex-shrink-3">
              <p>1km charge</p>
            </ListItemCell>
            <ListItemCell className="width-auto flex-shrink-4">
              <input
                type="number"
                style={{
                  textAlign: "center",
                }}
                placeholder={cityData.kmPerDeliveryCharge}
                value={kmPerDeliveryCharge}
                onChange={(e) => setKmPerDeliveryCharge(e.target.value)}
                onFocus={_ => setButtonSave(true)}
                onBlur={_ => setButtonSave(false)}
              />
            </ListItemCell>
            <ListItemCell className="width-auto flex-shrink-0">
              <h6>
                [
                <span id="default-delivery-charge">
                  NGN {kmPerDeliveryCharge || cityData.kmPerDeliveryCharge}
                </span>{" "}
                per km]
              </h6>
            </ListItemCell>
          </ListItem>
        </List>
      </CardContent>
      <CardFooter className="bg-color-white border-radius-0">
        <Button
          fill
          className="button-fill-red"
          iconF7="trash"
          onClick={() => {
            const delCity = f7.dialog.create({
              title: `Delete City Delivery Price`,
              text: `Are you sure you want to delete the base delivery price for ${city}?`,
              cssClass: "del-city",
              buttons: [
                {
                  text: "No, I'm not Sure",
                  cssClass: "button button-fill-blue",
                  close: true,
                },
                {
                  text: "Yes, I'm Sure",
                  onClick: function (dialog, e) {
                    deleteDeliveryPrice(country, state, city);
                  },
                  cssClass: "button button-fill-red",
                  close: true,
                },
              ],
              closeByBackdropClick: true,
            });
            delCity.open();
          }}
        />

        <Button
          // fill
          className={`${buttonSave ? "button-fill button-fill-blue" : "button-outline"}`}
          iconF7={`${buttonSave ? "" : "pencil_ellipsis_rectangle"}`}
          onClick={edit}
        >
          {`${buttonSave ? "Save Price" : "  Save Price"}`}
        </Button>
      </CardFooter>
    </Card>
  );
}

export default DeliveryPriceCity;
